import { throttle } from 'lodash';

export function windowAction() {
  const observeArea = document.querySelector('.js-observe');
  const headerEle = document.querySelector('.js-header');

  window.addEventListener(
    'scroll',
    _.throttle(
      (e) => {
        pageTopView();
        eleWatch(observeArea, headerEle, 'is-scrolled');
        return false;
      },
      10,
      { trailing: true, leading: true }
    )
  );

  window.addEventListener(
    'resize',
    _.throttle(
      (e) => {
        pageTopView();
        eleWatch(observeArea, headerEle, 'is-scrolled');
        return false;
      },
      10,
      { trailing: true, leading: true }
    )
  );

  // ページ読み込み時にスクロールトップボタンがkvより下にあれば表示
  window.addEventListener('load', () => {
    pageTopView();
    eleWatch(observeArea, headerEle, 'is-scrolled');
  });

  /** 画面処理 */
  // ページトップに戻るボタンの表示・非表示
  function pageTopView() {
    const pageTopBtn = document.querySelector('.js-pageTopBtn');
    const scroll = window.pageYOffset;

    // スクロール量がkvの高さを超えたらページトップボタンを表示
    if (scroll > 200) {
      pageTopBtn.classList.add('is-view');
    } else {
      pageTopBtn.classList.remove('is-view');
    }
  }

  // 対象Aと対象Bの交差を検知する
  function eleWatch(targetEleA, targetEleB, setClass) {
    const scroll = window.pageYOffset;
    const eleB = targetEleB;

    // 要素の位置座標を取得
    const clientRect = targetEleA.getBoundingClientRect();

    // ページの上端から、要素の上端までの距離
    const pageY = scroll + clientRect.top;

    if (scroll >= pageY) {
      eleB.classList.add(setClass);
    } else {
      eleB.classList.remove(setClass);
    }
  }
  /** end 画面処理 */
}
